import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import { useState } from "react";
import { formatDateTime } from "../../../utils/functions/formatters";
import { isValidPosition } from "../../../utils/functions/functions";
import { LocationTick, Profile, Truck } from "iconsax-react";

const FleetPositionMarker: React.FC<{ data: any, color?: string }> = ({ data, color }) => {
  const [showInfoWindowByIndex, setShowInfoWindowByIndex] = useState(false);
  const [markerRef, marker] = useAdvancedMarkerRef();
  const backgroundColor = color == null ? '#DA1E27' : color;

  return isValidPosition(data?.position) ? (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={data.position}
        onClick={() => setShowInfoWindowByIndex(true)}
      >
        <div
          className="w-fit"
          onMouseOver={() => setShowInfoWindowByIndex(true)}
          onMouseOut={() => setShowInfoWindowByIndex(false)}
        >
          <div
            className="w-fit absolute flex items-center justify-center top-[-20px] left-[12px] rounded-full p-2"
            style={{ backgroundColor: backgroundColor }}
          >
            <LocationTick
                variant="Bold"
                size="22"
                color="#FFFFFF"
                className="text-white"
              />
          </div>
        </div>
      </AdvancedMarker>
      {showInfoWindowByIndex && (
        <InfoWindow
          pixelOffset={[30, -30]}
          anchor={marker}
          maxWidth={200}
          headerDisabled
        >
          {data?.tag && (
            <>
              <span className="font-semibold">Placa:</span> {data?.tag}
              <br />
            </>
          )}
          <span className="font-semibold">Colaborador:</span> {data?.user}
          <br />
          <span className="font-semibold">Evento:</span> {data?.journeyEvent}
          <br />
          <span className="font-semibold">Início em:</span>{" "}
          {formatDateTime(data?.startedAt)}
        </InfoWindow>
      )}
    </>
  ) : null;
};

export default FleetPositionMarker;
